class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;
    const idInput = this.form.querySelector('[name=id]');
    if (idInput) idInput.disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(event) {
    if (window.shopSettings.cartType !== 'drawer' || !this.cartDrawer) return;
    event.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.setLoading(true);
    this.hideError();

    const formData = new FormData(this.form);
    formData.append(
      'sections',
      ['cart-drawer', 'cart-icon-bubble'].join(',')
    );
    formData.append('sections_url', window.location.pathname);

    fetch(`${window.routes.cart_add_url}`, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.showError(response.description || response.message);
          return;
        }
        this.cartDrawer.renderContents(response);
      })
      .catch(() => this.showError(window.cartStrings.error))
      .finally(() => this.setLoading(false));
  }

  setLoading(state) {
    if (!this.submitButton) return;
    this.submitButton.setAttribute('aria-disabled', state);
    this.submitButton.classList.toggle('loading', state);
    const spinner = this.submitButton.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !state);
  }

  showError(message) {
    if (!this.errorWrapper) return;
    this.errorWrapper.removeAttribute('hidden');
    const target = this.errorWrapper.querySelector('.product-form__error-message');
    if (target) target.textContent = message;
  }

  hideError() {
    if (this.errorWrapper) this.errorWrapper.setAttribute('hidden', '');
  }
}
customElements.define('product-form', ProductForm);
